import { useFilterParameterStore } from "presentation/stores/use-filter-parameter-store";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useState } from "react";

const HeaderParameterGrid: React.FC = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterParameterStore();

  const clearFilter = () => {
    resetFilters();
    setGlobalFilterValue("");
    setFilters({
      query: { value: "", matchMode: "contains" },
      type: { value: "", matchMode: "equals" },
      value: { value: "", matchMode: "equals" },
    });
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      let _filters = { ...filters };
      // @ts-ignore
      _filters["query"].value = globalFilterValue;
      setFilters(_filters);
    }
  };

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(e.target.value);
  };

  return (
    <div className="flex justify-content-between">
      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder="Search"
          />
        </IconField>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderParameterGrid;
